import React from "react";
import AppTemplate from "../components/Form5";

const Form5: React.FC = () => {
  return (
    <AppTemplate>
      <>ダッシュボード</>;
    </AppTemplate>
  );
};

export default Form5;
